import { Component, Input } from '@angular/core';

@Component({
  template: require('./table-cell.select.component.html')
})
export class TableCellSelectComponent {
  @Input() record : any;
}
